import React from 'react'
import { Formik, Field, Form, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import styled from 'styled-components'
const Button = styled('button')`
  background-color: #45c1b8;
  border-color: 40a9ff;
  border-radius: 2px;
  &:hover {
    background-color: #40a9ff;
  }
`
const CancelBookingForm = ({ onSubmit }) => (
  <Formik
    initialValues={{
      cause: ''
    }}
    onSubmit={(values, { resetForm }) => {
      onSubmit(values)
      resetForm()
    }}
    validationSchema={Yup.object().shape({
      cause: Yup.string().required('กรุณาระบุสาเหตุของการยกเลิก')
    })}
    render={({ errors, status, touched }) => (
      <Form>
        <div className="form-group" className="text-center">
          <label htmlFor="cause">โปรดระบุสาเหตุที่ยกเลิกรายการนัดหมายนี้</label>
          <Field name="cause" type="text" className={`form-control${errors.cause && touched.cause ? ' is-invalid' : ''} my-3`} />
          <ErrorMessage name="cause" component="div" className="invalid-feedback" />
        </div>

        <div className="form-group text-right">
          <Button type="submit" className="btn btn-primary">
            ยืนยัน
          </Button>
        </div>
      </Form>
    )}
  />
)

export default CancelBookingForm
